export const specials = [
  {
    id: "deep-space-dialogue",
    title: "深海与星空的对话",
    subtitle: "当人类仰望星空，也潜入深海",
    intro:
      "从马里亚纳海沟的幽暗，到百光年外的星云，人类对未知的想象从未停止。本专题精选一批科幻与探索题材影视，带你在同一段时光里，同时抵达海洋最深处与宇宙最远方。",
    reason:
      "如果你喜欢宏大世界观与硬核想象力，这一组作品会用最辽阔的尺度，重新丈量人类的渺小与勇敢。",
    cover: "https://readdy.ai/api/search-image?query=surreal%20cinematic%20artwork%20splitting%20the%20frame%20between%20a%20deep%20ocean%20trench%20and%20a%20vast%20star%20nebula%2C%20bioluminescent%20creatures%20meeting%20glowing%20stars%2C%20deep%20navy%20and%20teal%20tones%20with%20warm%20orange%20highlights%2C%20high%20detail&width=900&height=500&seq=sp-01&orientation=landscape",
    groups: [
      {
        name: "星辰之约",
        description: "在浩瀚宇宙中，人类如何寻找自己的位置。",
        movieIds: ["sea-of-stars", "under-neon"]
      },
      {
        name: "深海之问",
        description: "海洋深处隐藏的，是科学还是人心。",
        movieIds: ["deep-sea-echo", "blue-planet-chronicle"]
      }
    ],
    relatedIds: ["mystery-highscore", "world-documentaries"]
  },
  {
    id: "mystery-highscore",
    title: "悬疑推理高分榜",
    subtitle: "抽丝剥茧，直到最后一个镜头",
    intro:
      "真相往往藏在最不起眼的细节里。我们整理了一批口碑在线的悬疑与推理作品，从雨夜都市到迷雾小镇，每一部都值得你戴上耳机、关掉灯，一口气看到结尾。",
    reason: "剧情缜密、反转扎实，适合喜欢边看边推理、享受解谜快感的观众。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20noir%20scene%20of%20a%20dark%20detective%20desk%20covered%20with%20clues%2C%20photographs%20and%20red%20string%20boards%2C%20a%20single%20warm%20lamp%2C%20deep%20navy%20and%20charcoal%20tones%20with%20orange%20glow%2C%20mysterious%20high%20detail&width=900&height=500&seq=sp-02&orientation=landscape",
    groups: [
      {
        name: "都市谜案",
        description: "灯火通明的城市里，藏着最深的秘密。",
        movieIds: ["end-of-long-night", "silent-testimony", "undercurrent"]
      },
      {
        name: "迷雾与回响",
        description: "当记忆与真相一起模糊。",
        movieIds: ["kyoto-mist", "fog-detective-agency", "deep-sea-echo"]
      }
    ],
    relatedIds: ["deep-space-dialogue", "healing-city-life"]
  },
  {
    id: "healing-city-life",
    title: "治愈系都市生活",
    subtitle: "在平凡日子里，被温柔接住",
    intro:
      "如果最近有点累，不妨给自己放个慢下来的假。这组作品没有激烈的冲突，只有灶台的烟火、深夜的灯光与陌生人的善意，适合在安静的夜晚慢慢看。",
    reason: "节奏舒缓、情绪温暖，非常适合用来缓解压力、找回生活的踏实感。",
    cover: "https://readdy.ai/api/search-image?query=warm%20cozy%20illustration%20of%20a%20city%20evening%20with%20lit%20windows%2C%20small%20neighborhood%20shops%20and%20string%20lights%2C%20deep%20navy%20and%20teal%20tones%20with%20rich%20warm%20orange%20glow%2C%20comforting%20and%20high%20detail&width=900&height=500&seq=sp-03&orientation=landscape",
    groups: [
      {
        name: "人间烟火",
        description: "一饭一蔬之间，都是生活的答案。",
        movieIds: ["city-fireworks", "philosophy-of-kitchen"]
      },
      {
        name: "温柔时刻",
        description: "关于相遇、遗憾与重新出发。",
        movieIds: ["time-post-office", "journey-train"]
      }
    ],
    relatedIds: ["world-documentaries", "mystery-highscore"]
  },
  {
    id: "world-documentaries",
    title: "世界纪录片精选",
    subtitle: "看见真实世界，比故事更动人",
    intro:
      "纪录片最大的魅力，在于它不虚构，却比虚构更震撼。本专题汇集自然、人文与地理题材的优质纪录片，带你用最短的时间，看见这颗星球最真实的模样。",
    reason: "画面与知识密度兼具，适合全家一起观看，也适合当作了解世界的窗口。",
    cover: "https://readdy.ai/api/search-image?query=awe%20inspiring%20view%20of%20planet%20earth%20from%20space%20showing%20continents%20and%20oceans%2C%20glowing%20blue%20atmosphere%2C%20deep%20navy%20and%20teal%20tones%20with%20warm%20orange%20sunlight%20edge%2C%20high%20detail&width=900&height=500&seq=sp-04&orientation=landscape",
    groups: [
      {
        name: "自然的低语",
        description: "从深海到高山，感受地球的呼吸。",
        movieIds: ["blue-planet-chronicle", "between-mountains-and-seas"]
      },
      {
        name: "人间与时代",
        description: "记录普通人在时间里的模样。",
        movieIds: ["silent-snow", "philosophy-of-kitchen"]
      }
    ],
    relatedIds: ["deep-space-dialogue", "healing-city-life"]
  }
];